import * as React from 'react';
// import Slider from 'react-rangeslider'
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css"
import "./ratioSlider.less";
import { useState, useEffect } from 'react';

export interface PercentSliderProps {
    onChange: (ratio: number) => void,
    defaultRatio: number;
}

export const PercentSlider = (props: PercentSliderProps) => {

    //    const { ratio } = props;

    const [sliderRatio, setSliderRatio] = useState(props.defaultRatio);
    useEffect(() => { setSliderRatio(props.defaultRatio) }, [props.defaultRatio])
    // debugger; 

    const v = Math.min(Math.max(sliderRatio * 100, 0), 100);
    return <InputRange
        maxValue={100}
        minValue={0}
        value={v}
        onChange={v => setSliderRatio((v as number) / 100)}
        onChangeComplete={v => {
            // debugger;
            props.onChange((v as number) / 100)
        }}
        formatLabel={v => ""}
    />

    // <Slider
    //     min={0}
    //     max={100}
    //     value={v}
    //     // labels={horizontalLabels}
    //     format={v => `${v}%`}
    //     // handleLabel={horizontal}
    //     onChange={this.handleChangeHorizontal}
    // />

}